import { z } from "zod"
import { GradeSchema, MajorSchema } from "./Lesson"
import { requiredFieldMessage } from "./General";

export const ThemeSchema = z.enum(['ice', 'sunny', 'patterned-ice', 'patterned-sunny', 'custom'])

export const StudentBasicSchema = z.object({
    id: z.number(),
    grade: GradeSchema,
    major: MajorSchema,
    counselor_id: z.number().or(z.string()).optional().nullable(),
    school: z.string().optional().nullable(),
    goal: z.string().optional().nullable(),
    nick_name: z.string().optional().nullable(),
    active: z.boolean().optional().nullable(),
    user_id: z.number(),
    chat_id: z.string().optional().nullable()
})

export const StudentSchema = StudentBasicSchema.extend({
    name: z.string(),
    profilePic: z.string(),
    phoneNumber: z.string(),
    smsActive: z.boolean().optional().nullable(),
    secondaryPhoneNumber: z.string().optional().nullable()
})

export const CounselorBasicSchema = z.object({
    id: z.number(),
    code: z.string(),
    capacity: z.number(),
    admin_id: z.number().optional().nullable(),
})

export const CounselorSchema = CounselorBasicSchema.extend({
    name: z.string(),
    profilePic: z.string()
})

export const RegisterSchema = z.object({
    role: z.string({ required_error: requiredFieldMessage }),
    sex: z.number().min(1).max(2),
    code: z.string().optional().nullable(),
    name: z.string({ required_error: requiredFieldMessage }).min(1, { message: requiredFieldMessage }),
    grade: z.number().min(1).max(10).optional(),
    major: z.number().min(0).max(3).optional(),
    phoneNumber: z.string({ required_error: requiredFieldMessage }).min(1, { message: requiredFieldMessage }),
    password: z.string({ required_error: requiredFieldMessage }).min(8, { message: 'رمز باید حداقل 8 کاراکتر داشته باشد' }),
    confirmPassword: z.string({ required_error: requiredFieldMessage }),
    admin_code: z.string().optional().nullable(),
    counselor_code: z.string().optional().nullable()
}).refine((data) => data.confirmPassword === data.password, {
    message: 'پسورد با تکرار آن تطابق ندارد',
    path: ['confirmPassword']
})

const UserSchema = z.object({
    id: z.number(),
    name: z.string(),
    balance: z.number(),
    nationalCode: z.string().optional().nullable(),
    phoneNumber: z.string(),
    profilePic: z.string(),
    theme: ThemeSchema.optional(),
    chatFontSize: z.number().min(13).max(20).optional(),
    status: z.number(),
    role: z.number(),
    score: z.number().optional(),
    is_demo: z.boolean().optional(),
    school_id: z.number().optional().nullable()
})

const CounselorLoginSchema = UserSchema.extend({
    special: CounselorBasicSchema
})

const CounselorUserSchema = UserSchema.extend({
    special: CounselorSchema
})

const StudentLoginSchema = UserSchema.extend({
    special: StudentBasicSchema
})

const StudentUserSchema = UserSchema.extend({
    special: StudentSchema
})

export const LoginDataSchema = z.object({
    user: StudentLoginSchema.or(CounselorLoginSchema),
    token: z.string()
})

export const StudentServerResponseSchema = z.array(StudentSchema)

export type StudentLoginType = z.infer<typeof StudentLoginSchema>
export type CounselorLoginType = z.infer<typeof CounselorLoginSchema>
export type StudentType = z.infer<typeof StudentSchema>;
export type CounselorType = z.infer<typeof CounselorSchema>;

export type ThemeType = z.infer<typeof ThemeSchema>;
export type RegisterType = z.infer<typeof RegisterSchema>;
export type CounselorUserType = z.infer<typeof CounselorUserSchema>
export type StudentUserType = z.infer<typeof StudentUserSchema>